var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-head",style:({'background-color':_vm.bg?_vm.bg:'inherit'})},[_c('h1',{staticClass:"fs30"},[_vm._v(_vm._s(_vm.title))]),_c('h2',{staticClass:"fs20"},[_vm._v(_vm._s(_vm.subTitle))]),_c('p',{staticClass:"main-txt",domProps:{"innerHTML":_vm._s(_vm.desc)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }